import React from "react";
import CalendarNavigation from "./CalendarNavigation";
import CalendarGrid from "./CalendarGrid";

const CalendarMain = ({
  currentDate,
  monthNames,
  dayNames,
  days,
  selectedDates,
  vacationDates,
  dateRangeStart,
  dateRangeEnd,
  dateRangeMode,
  getEventsForDate,
  styles,
  screenSize,
  language,
  theme,
  t,
  handlePrevMonth,
  handleNextMonth,
  handleButtonHover,
  onDateClick,
  onEventClick,
  onSelectMonth,
  onShowMoreEvents,
}) => {
  return (
    <div id="calendar-export" style={styles.calendarMain}>
      <CalendarNavigation
        currentDate={currentDate}
        monthNames={monthNames}
        styles={styles}
        screenSize={screenSize}
        language={language}
        theme={theme}
        handlePrevMonth={handlePrevMonth}
        handleNextMonth={handleNextMonth}
        handleButtonHover={handleButtonHover}
        onSelectMonth={onSelectMonth}
      />

      <CalendarGrid
        days={days}
        dayNames={dayNames}
        selectedDates={selectedDates}
        vacationDates={vacationDates}
        dateRangeStart={dateRangeStart}
        dateRangeEnd={dateRangeEnd}
        dateRangeMode={dateRangeMode}
        getEventsForDate={getEventsForDate}
        styles={styles}
        screenSize={screenSize}
        language={language}
        t={t}
        onDateClick={onDateClick}
        onEventClick={onEventClick}
        onShowMoreEvents={onShowMoreEvents}
      />
    </div>
  );
};

export default CalendarMain;
